'use client';

import { c as _c } from "react/compiler-runtime";
import ClerkFormTermsAndPrivacyFooter from '@/components/auth/ClerkFormTermsAndPrivacyFooter';
import GoogleLoginHintButton from '@/components/auth/GoogleLoginHintButton';
import { HIDE_CLERK_SOCIAL_BUTTONS } from '@/components/auth/hideClerkSocialButtons';
import { OTHER_EMAIL_PARAM } from '@/lib/purchaseClaim/claimRedirect';
import { SignIn } from '@clerk/nextjs';
import { ClerkLoaded } from '@clerk/nextjs';
import { useState } from 'react';
interface LoginClientProps {
  /** The purchase email to prefill and offer Google for (it has a login). */
  purchaseEmail: string;
  /** Where the Google button lands once signed in. */
  afterSignInUrl: string;
}
export default function LoginClient(t0) {
  const $ = _c(22);
  const {
    purchaseEmail,
    afterSignInUrl
  } = t0;
  const [otherEmail, setOtherEmail] = useState(false);
  const withPurchaseEmail = !!purchaseEmail && !otherEmail;
  let t1;
  if ($[0] !== afterSignInUrl || $[1] !== purchaseEmail || $[2] !== withPurchaseEmail) {
    t1 = withPurchaseEmail && <div className="w-full px-8 pt-6"><GoogleLoginHintButton email={purchaseEmail} mode="signIn" afterSignInUrl={afterSignInUrl} /></div>;
    $[0] = afterSignInUrl;
    $[1] = purchaseEmail;
    $[2] = withPurchaseEmail;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = otherEmail ? "other" : "purchase";
  let t3;
  if ($[4] !== purchaseEmail || $[5] !== withPurchaseEmail) {
    t3 = withPurchaseEmail ? {
      emailAddress: purchaseEmail
    } : undefined;
    $[4] = purchaseEmail;
    $[5] = withPurchaseEmail;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== withPurchaseEmail) {
    t4 = withPurchaseEmail ? {
      elements: HIDE_CLERK_SOCIAL_BUTTONS
    } : undefined;
    $[7] = withPurchaseEmail;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = purchaseEmail ? `/signup?${OTHER_EMAIL_PARAM}=1` : undefined;
  let t6;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <SignIn key={t2} initialValues={t3} appearance={t4} signUpUrl={t5} />;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== otherEmail || $[15] !== purchaseEmail) {
    t7 = purchaseEmail && <button type="button" onClick={() => setOtherEmail(!otherEmail)} className="mb-4 text-sm font-medium text-poppy-purple-color hover:underline">{otherEmail ? `← Back to ${purchaseEmail}` : "Want to use a different email? \u2192"}</button>;
    $[14] = otherEmail;
    $[15] = purchaseEmail;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ClerkFormTermsAndPrivacyFooter />;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t1 || $[19] !== t6 || $[20] !== t7) {
    t9 = <div className="flex min-h-full items-center justify-center"><div className="flex w-full flex-col p-4 md:p-8 lg:w-1/2"><div className="shadow-poppy-purple-color/20 mx-auto flex w-fit max-w-[25rem] flex-1 flex-col items-center justify-center rounded-xl bg-white shadow-xl"><ClerkLoaded>{t1}{t6}{t7}{t8}</ClerkLoaded></div></div></div>;
    $[18] = t1;
    $[19] = t6;
    $[20] = t7;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}